// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SubaccountsFranchises_ProvidersResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for GET /payments/accounts/providers
 *
 * List of active payment providers for the requested country.
 */
import type { SubaccountsFranchises_ProvidersRow } from './SubaccountsFranchises_ProvidersRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type SubaccountsFranchises_ProvidersResponseDados = SubaccountsFranchises_ProvidersRow[];

export type SubaccountsFranchises_ProvidersResponse = ApiResponse<SubaccountsFranchises_ProvidersResponseDados>;

registerResponseContract('SubaccountsFranchises_ProvidersResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      id:                { type: 'number',  required: true },
      code:              { type: 'string',  required: true },
      name:              { type: 'string',  required: true },
      description:       { type: 'string',  required: false },
      country_codes:     { type: 'string',  required: true },
      supported_methods: { type: 'array',   required: false },
      capabilities:      { type: 'object',  required: false },
      config_schema:     { type: 'object',  required: false },
      webhook_url:       { type: 'string',  required: false },
      api_base_url:      { type: 'string',  required: false },
      sandbox_api_url:   { type: 'string',  required: false },
      logo_url:          { type: 'string',  required: false },
      active:            { type: 'number',  required: true },
      created_at:        { type: 'string',  required: false },
      updated_at:        { type: 'string',  required: false },
    },
  },
})
